var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectMoneyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1819",
    "data-name": "Group 1819",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.158,
    height: 16,
    viewBox: "0 0 15.158 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2883",
    "data-name": "Rectangle 2883",
    width: 15.158,
    height: 16,
    fill: "#00b4d9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1820",
    "data-name": "Group 1820",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3264",
    "data-name": "Path 3264",
    d: "M7.579,0a13.07,13.07,0,0,1,5.1.935,5.354,5.354,0,0,1,1.711,1.122,2.547,2.547,0,0,1,.76,1.565l.007.168v8.421a2.5,2.5,0,0,1-.766,1.733,5.4,5.4,0,0,1-1.711,1.122,13.07,13.07,0,0,1-5.1.935,13.07,13.07,0,0,1-5.1-.935A5.4,5.4,0,0,1,.766,13.944a2.547,2.547,0,0,1-.76-1.565L0,12.211V3.789A2.5,2.5,0,0,1,.766,2.056,5.373,5.373,0,0,1,2.477.935,13.07,13.07,0,0,1,7.579,0m5.895,10.449a7.035,7.035,0,0,1-.793.406,13.07,13.07,0,0,1-5.1.935,13.07,13.07,0,0,1-5.1-.935,7.036,7.036,0,0,1-.793-.406v1.762a.831.831,0,0,0,.293.561,3.693,3.693,0,0,0,1.176.751,11.43,11.43,0,0,0,4.426.793,11.43,11.43,0,0,0,4.426-.793,3.693,3.693,0,0,0,1.176-.751.831.831,0,0,0,.293-.561Zm0-4.211a7.035,7.035,0,0,1-.793.406,13.07,13.07,0,0,1-5.1.935,13.07,13.07,0,0,1-5.1-.935,7.035,7.035,0,0,1-.793-.406V8a.831.831,0,0,0,.293.561,3.693,3.693,0,0,0,1.176.751,11.43,11.43,0,0,0,4.426.793,11.43,11.43,0,0,0,4.426-.793,3.693,3.693,0,0,0,1.176-.751A.828.828,0,0,0,13.474,8ZM7.579,1.684a11.4,11.4,0,0,0-4.426.793,3.693,3.693,0,0,0-1.176.751.828.828,0,0,0-.293.561.831.831,0,0,0,.293.561A3.693,3.693,0,0,0,3.153,5.1a11.4,11.4,0,0,0,4.426.793A11.4,11.4,0,0,0,12.005,5.1a3.693,3.693,0,0,0,1.176-.751.828.828,0,0,0,.293-.561.831.831,0,0,0-.293-.561,3.693,3.693,0,0,0-1.176-.751,11.4,11.4,0,0,0-4.426-.793",
    fill: "#00b4d9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectMoneyIcon);
export default __webpack_public_path__ + "static/media/project_money_icon.88ae459ad7ca0fa18f617ffb7c1212bb.svg";
export { ForwardRef as ReactComponent };